import { Helmet } from 'react-helmet-async';

export default function PrivacyPage() {
  return (
    <>
      <Helmet><title>Privacy Policy | BESTIX</title></Helmet>
      <div className="min-h-screen bg-gray-50">
        <div className="bg-navy py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="font-playfair text-4xl font-bold !text-white">Privacy Policy</h1>
            <p className="mt-4 text-gray-300">Last updated: January 2026</p>
          </div>
        </div>
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto prose prose-navy">
            
            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-navy mb-4">Introduction</h2>
              <p className="text-gray-600 mb-4">
                BESTIX by BESPOKIAN ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
              <p className="text-gray-600">
                Please read this privacy policy carefully. By using our services, you consent to the practices described in this policy.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-navy mb-4">Information We Collect</h2>
              
              <h3 className="text-lg font-semibold text-navy mb-2">Personal Information</h3>
              <p className="text-gray-600 mb-4">We may collect personal information that you voluntarily provide, including:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
                <li>Name, email address, and phone number</li>
                <li>Billing and shipping address</li>
                <li>Payment information (processed securely through our payment providers)</li>
                <li>Account credentials</li>
                <li>Communication preferences</li>
              </ul>

              <h3 className="text-lg font-semibold text-navy mb-2">Automatically Collected Information</h3>
              <p className="text-gray-600 mb-4">When you access our services, we automatically collect:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Device information (browser type, operating system)</li>
                <li>IP address and location data</li>
                <li>Usage data and browsing patterns</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-navy mb-4">How We Use Your Information</h2>
              <p className="text-gray-600 mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Process and fulfill ticket purchases</li>
                <li>Provide customer support and respond to inquiries</li>
                <li>Send transactional emails (order confirmations, ticket delivery)</li>
                <li>Improve our website and services</li>
                <li>Detect and prevent fraud</li>
                <li>Comply with legal obligations</li>
                <li>Send marketing communications (with your consent)</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-navy mb-4">Information Sharing</h2>
              <p className="text-gray-600 mb-4">We may share your information with:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li><strong>Service Providers:</strong> Payment processors, email services, and analytics providers</li>
                <li><strong>Ticket Sellers:</strong> Information necessary to fulfill your order</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
                <li><strong>Business Transfers:</strong> In connection with mergers or acquisitions</li>
              </ul>
              <p className="text-gray-600 mt-4">
                We do not sell your personal information to third parties for their marketing purposes.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-navy mb-4">Data Security</h2>
              <p className="text-gray-600">
                We implement industry-standard security measures to protect your personal information, including encryption, secure servers, and regular security audits. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-navy mb-4">Your Rights</h2>
              <p className="text-gray-600 mb-4">Depending on your location, you may have the right to:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Access, correct, or delete your personal information</li>
                <li>Opt out of marketing communications</li>
                <li>Request data portability</li>
                <li>Withdraw consent</li>
                <li>Lodge a complaint with a supervisory authority</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-navy mb-4">Contact Us</h2>
              <p className="text-gray-600">
                If you have questions about this Privacy Policy or our data practices, please contact us at:
              </p>
              <p className="text-navy font-semibold mt-4">
                privacy@bestix.ai
              </p>
            </section>

          </div>
        </div>
      </div>
    </>
  );
}
